export default __webpack_public_path__ + "static/media/7.e7e735b5.png";